/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mRank.vue?vue&type=template&id=4dcea450"
import script from "./mRank.vue?vue&type=script&lang=js"
export * from "./mRank.vue?vue&type=script&lang=js"
import style0 from "./mRank.vue?vue&type=style&index=0&id=4dcea450&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports